import { useAuth } from '@/core/contexts/AuthContext';
import { logger } from '@/core/logger';
import { useCallback } from 'react';

/**
 * Custom hook for logout functionality
 * Handles logout process and navigation
 */
export const useLogout = () => {
    const { logout: clearAuthState } = useAuth();

    /**
     * Handle logout process
     */
    const logout = useCallback(async (): Promise<void> => {
        try {
            logger.info('useLogout:Starting logout process');

            // Clear authentication state and storage
            await clearAuthState();

            // Navigation is handled by Stack.Protected - no manual navigation needed!
            logger.info('useLogout:Logout successful');
        } catch (error) {
            logger.error('useLogout:Logout failed', error);
            // Still clear local state even if logout fails
            await clearAuthState();
        }
    }, [clearAuthState]);

    return {
        logout,
    };
};
